import React from 'react';

const SvgBack = (props) => (
    <svg width={5} height={9} {...props} viewBox="0 0 5 9">
        <path d="M5 7.939L1.908 4.5 5 1.061 4.046 0 0 4.5 4.046 9z" fill={props.color || '#FFF'} fillRule="evenodd" />
    </svg>
);

export default SvgBack;
